import { render, staticRenderFns } from "./SessionPrivateTwoStagedOffersInfo.vue?vue&type=template&id=8b7bb82e&scoped=true&"
import script from "./SessionPrivateTwoStagedOffersInfo.vue?vue&type=script&lang=js&"
export * from "./SessionPrivateTwoStagedOffersInfo.vue?vue&type=script&lang=js&"
import style0 from "./SessionPrivateTwoStagedOffersInfo.vue?vue&type=style&index=0&id=8b7bb82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bb82e",
  null
  
)

export default component.exports